import axios from "axios";
import store from "@/state/store";

export const state = {
  tokens: [],
  tokensParsed: [],
};

export const mutations = {
  SET_TOKEN(state, payload) {
    const tokenIndex = state.tokens.findIndex(
      (t) => t.idUsuario == payload.idUsuario
    );
    if (tokenIndex >= 0) {
      state.tokens.splice(tokenIndex, 1);
    } else {
      state.tokens.push(payload);
    }
    store.commit("auth/SET_TOKEN", payload.token);
    store.commit("atendimento/SET_SPLASH", true);
    setTimeout(() => {
      store.commit("loader/SET_LOADING", false);
    });
    localStorage.setItem("multiTokens", JSON.stringify(state.tokens));
  },
  SET_TOKEN_PARSED(state, payload) {
    const tokenIndex = state.tokensParsed.findIndex(
      (t) => t.idUsuario == payload.idUsuario
    );
    if (tokenIndex >= 0) {
      state.tokensParsed.splice(tokenIndex, 1);
    } else {
      const nullIndex = state.tokensParsed.findIndex((t) => !t.idUsuario);
      if (nullIndex >= 0) {
        state.tokensParsed.splice(nullIndex, 1, payload);
      } else {
        state.tokensParsed.push(payload);
      }
    }
  },
};

export const getters = {
  isMultiAuth(state) {
    return Boolean(state.tokens.length);
  },
  getTokensParsed(state) {
    return state.tokensParsed;
  },
};

export const actions = {
  async signIn({ dispatch }, payload) {
    var url = process.env.VUE_APP_AUTH_LOGIN;
    await axios({
      method: "post",
      url: url,
      data: payload,
      headers: { "content-type": "application/x-www-form-urlencoded" },
    })
      .then((response) => {
        return dispatch("getUserInfo", [
          {
            idUsuario: null,
            token: response.data.access_token,
            refreshToken: response.data.refresh_token,
          },
        ]);
      })
      .catch(() => {});
  },

  getUserInfo({ commit }, tokens) {
    if (!tokens?.length) {
      return;
    }

    var url = process.env.VUE_APP_AUTH_USER;

    tokens.forEach(async (token) => {
      try {
        await axios({
          method: "get",
          url: url,
          headers: { Authorization: "Bearer " + token.token },
        }).then((response) => {
          commit("SET_TOKEN", {
            idUsuario: response.data.sub,
            token: token.token,
            refreshToken: token.refreshToken,
          });
          store.commit("sessao/SET_TOTEM", { idTotem: response.data.TOTEM });
          return commit("SET_TOKEN_PARSED", {
            idUsuario: response.data.sub,
            tokenParsed: response.data,
          });
        });
      } catch (error) {
        commit("SET_TOKEN_PARSED", {
          idUsuario: token.idUsuario,
          tokenParsed: {},
        });
        commit("SET_TOKEN", {
          idUsuario: token.idUsuario,
          token: null,
          refreshToken: null,
        });
        localStorage.clear();
        location.reload();
      }
    });
  },

  async signOut({ commit, state }, idUsuario) {
    var url = process.env.VUE_APP_AUTH_LOGOUT;

    const userToken = state.tokens.find((t) => t.idUsuario == idUsuario);

    if (!userToken) return;

    const token = userToken.token;
    const refreshToken = userToken.refreshToken;

    if (!token || !refreshToken) return;

    var bodyFormData = new URLSearchParams();
    bodyFormData.append("client_id", process.env.VUE_APP_AUTH_CLIENT_ID);
    bodyFormData.append("refresh_token", refreshToken);

    return await axios({
      method: "post",
      url: url,
      data: bodyFormData,
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + token,
      },
    }).then(() => {
      commit("SET_TOKEN_PARSED", { idUsuario, tokenParsed: {} });
      commit("SET_TOKEN", { idUsuario, token: null, refreshToken: null });
    });
  },
};
